import { Node } from 'tiptap'

export default class TiptapCourseTag extends Node {
  get name() {
    return 'courseTag'
  }
  commands({ type, schema }) {
    return attrs => (state, dispatch) => {
      const results = []
      const mergedTextNodes = []
      let index = 0

      state.tr.doc.descendants((node, pos) => {
        if (node.isText) {
          if (mergedTextNodes[index]) {
            mergedTextNodes[index] = {
              text: mergedTextNodes[index].text + node.text,
              pos: mergedTextNodes[index].pos,
            }
          } else {
            mergedTextNodes[index] = {
              text: node.text,
              pos,
            }
          }
        } else {
          index += 1
        }
      })
      mergedTextNodes.forEach(({ text, pos }) => {
        const search = RegExp(attrs.searchTerm, 'gu')
        let m
        while ((m = search.exec(text))) {
          if (m[0] === '') break
          results.push({
            from: pos + m.index,
            to: pos + m.index + m[0].length,
          })
        }
      })
      const { from, to } = results[0]
      dispatch(state.tr.replaceWith(from, to, type.create(attrs)))
    }
  }
  get schema() {
    return {
      inline: true,
      attrs: {
        href: {},
        innerText: {}
      },
      group: 'inline',
      selectable: false,
      parseDOM: [{
        tag: 'a[href]',
        getAttrs: dom => ({
          href: dom.href,
          innerText: dom.innerText,
        }),
      }],
      toDOM: node => ['a', {
        href: node.attrs.href,
      }, node.attrs.innerText],
    }
  }
  get view() {
    return {
      props: ['node', 'updateAttrs', 'view'],
      computed: {
        href: {
          get() {
            return this.node.attrs.href
          },
          set(href) {
            this.updateAttrs({
              href
            })
          },
        },
        innerText: {
          get() {
            return this.node.attrs.innerText
          },
          set(innerText) {
            this.updateAttrs({
              innerText
            })
          },
        },
      },
      template: `
        <a :href="href">{{ innerText }}</a>
      `,
    }
  }
}